export const speakText = (text) => {
  try {
    if (!text || !window.speechSynthesis) return;
    window.speechSynthesis.cancel();
    const u = new window.SpeechSynthesisUtterance(text);
    u.rate = 0.85;
    u.pitch = 1.05;
    window.speechSynthesis.speak(u);
  } catch { /* noop */ }
};
